import { useEffect } from 'react';

import type { UseSuppliersEffectsProps } from '@app/pages/Warehouses/Suppliers/types';

export const useSuppliersEffects = ({
  onSearchHandler,
}: UseSuppliersEffectsProps) => {
  useEffect(() => {
    onSearchHandler();
  }, [onSearchHandler]);
};
